goog.declareModuleId('yext.ui.components.MarketingActivationPage');


import {Link} from '/ui/components/link/link';
import {LinkCard} from '/ui/components/marketingactivationpage/linkcard';
import * as Types from '/ui/components/marketingactivationpage/types';
import {ProgressBar} from '/ui/components/progressbar/progressbar';
import {yext} from '/ui/lib/msg';
import {useIsSmallViewport} from '/ui/lib/responsivity';

import * as styles from '/ui/components/marketingactivationpage/marketingactivationpage.module.scss';
import OpenBookSvg from '/ui/icons/inline/open-book.svg';

/**
 * @param {{
 *   image: React.ReactNode,
 *   header: string,
 *   description: (string | React.ReactNode),
 *   linkCardContents: (Array<!Types.LinkCardContent> | undefined),
 *   resourceLabel: (string | undefined),
 *   resourceHref: (string | undefined),
 *   primaryCtaLabel: (string | undefined),
 *   primaryCtaHref: (string | undefined),
 *   progressBarValue: (number | null | undefined),
 * }} props
 * @returns {React.ReactElement}
 */
export function MarketingActivationPage({
  image,
  header,
  description,
  linkCardContents,
  resourceLabel,
  resourceHref,
  primaryCtaLabel,
  primaryCtaHref,
  progressBarValue,
}) {
  if (!linkCardContents) {
    linkCardContents = [];
  }
  // We render the children in a different order for small viewports.
  const isSmallViewport = useIsSmallViewport();

  const linkCards = !!linkCardContents.length && (
    <div className={styles.linkCardsContainer}>
      {linkCardContents.map(lcc =>
        <LinkCard // Closure hates prop spread syntax combined with keys :(
          type={lcc.type}
          headline={lcc.headline}
          href={lcc.href}
          key={lcc.href}
        />)}
    </div>
  );

  const CtaArr = [];
  if (primaryCtaLabel && primaryCtaHref) {
    CtaArr.push(
      <Link
        href={primaryCtaHref}
        context="primary"
        key="primary"
      >
        {primaryCtaLabel}
      </Link>);
  }
  if (resourceLabel && primaryCtaLabel) {
    CtaArr.push(
      <Link
        href={resourceHref}
        icon={<OpenBookSvg/>}
        external
        key="resource"
      >
        {resourceLabel}
      </Link>);
  }
  const CtaElem = CtaArr.length === 0 ? null : (
    <div className={styles.ctaContainer}>
      {isSmallViewport ? CtaArr.reverse() : CtaArr}
    </div>
  );

  const progressBar = (progressBarValue || progressBarValue === 0) && (
    <div className={styles.progressBar}>
      <ProgressBar value={progressBarValue}/>
    </div>
  );

  return (
    <div
      className={styles.root}
    >
      <div className={styles.imageContainer}>{image}</div>
      <h1 className={styles.header}>{header}</h1>
      <div className={styles.description}>{description}</div>
      {progressBar}
      {isSmallViewport && linkCards}
      {CtaElem}
      {!isSmallViewport && linkCards}
    </div>
  );
}
